import React, { FC, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignInPage from "./SignInPage";
import { ApplicationState } from "src/store";
import userManager from "src/oidcClient/userService";
import { User } from "oidc-client";
import LoadingScreen from "./Common/Navigation/LoadingScreen";
import { loadingUser } from "src/actions/authActions";

const PreLogin: FC = () => {
    const location = useLocation();
    const authUser = useSelector((state: ApplicationState) => state.userAuth.user);
    const [user, setUser] = useState<User>(authUser);
    const [checkingUserLoggedIn, setCheckingUserLoggedIn] = useState<boolean>(true);
    const queryParams = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    const isLogoutDialog = sessionStorage.getItem("isLogoutDialog") === "true";
    useEffect(() => {
        if (location.pathname === "/" && Office.context.ui.messageParent) {
            Office.context.ui.messageParent("logout");
        }
        setCheckingUserLoggedIn(true);

        if (queryParams.has("signinRequired")) {
            setCheckingUserLoggedIn(false);
            return;
        }

        userManager.getUser().then((user: User) => {
            if (user != null && user.expired === false) {
                setUser(user);
                userManager.events.load(user);
            }
            setCheckingUserLoggedIn(false);
        });
        dispatch(loadingUser());
    }, []);

    return checkingUserLoggedIn ? <LoadingScreen></LoadingScreen> : !user ?
        (!Office.context.ui.displayDialogAsync ?
            <Navigate to="/login" state={{ from: location }} /> :
            <SignInPage redirectUrl={location.pathname} />) : <Navigate to="/login" state={{ from: location }} />;
};

PreLogin.displayName = "PreLogin";

export default PreLogin;
